import { FaShare } from "react-icons/fa";
import useSbConfig from "../Shared/useSbConfig";
import ActionButton from "../Shared/ActionButton";

export default ({
  wro
}) => {
  const {
    id
  } = wro

  const sbConfig = useSbConfig()

  const viewWRO = () => {
    // 1.0 ${sbConfig.merchantUrl}/App/merchant/#/inventory/receiving/${id}/summary/
    window.open(`${sbConfig.merchantUrl}/App/merchant/#/inventory/receiving/${id}/summary/`)
  }

  return (
    <ActionButton onClick={viewWRO}>
      <FaShare style={{ paddingRight: '10px' }} />
      View
    </ActionButton>
  )
}